<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="新增付款单"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
  > <i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span class="name">{{isEdit?"编辑付款单":"新增付款单"}}</span>
    </div>
    <div
      class="form_content"
      style="padding: 20px"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row class="form_head_title">

          客户信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="付款单编号:"
              prop="payment_no"
            >
              <el-input
                v-model="formData.payment_no"
                placeholder="保存后自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="付款单日期:"
              prop="payment_time"
            >
              <el-date-picker
                v-model="formData.payment_time"
                format="yyyy-MM-dd"
                placeholder="选择日期"
                disabled
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="客户名称:"
              prop="customer_name"
            >
              <el-input
                v-model="formData.customer_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人:"
              prop="contacts"
            >
              <el-input
                v-model="formData.contacts"
                disabled
              > </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话:"
              prop="contacts_phone"
            >
              <el-input
                v-model="formData.contacts_phone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">

          订单信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="订单编号:"
              prop="order_no"
            >
              <el-input
                v-model="formData.order_no"
                placeholder="保存后自动生成"
                disabled
              >
                <el-link
                  :inderline="false"
                  slot="append"
                  type="primary"
                  @click="showOrderDetail"
                >详情</el-link>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="订单日期:"
              prop="order_time"
            >
              <el-date-picker
                v-model="formData.order_time"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
                disabled
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="产品名称:"
              prop="account_name"
            >
              <el-input
                v-model="formData.account_name"
                placeholder="保存后自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="订单金额:"
              prop="order_amount"
            >
              <form-input
                :numberVal="formData.order_amount"
                :disabled="true"
                @setVal="setVal"
                :keyName="'order_amount'"
              ></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">

          付款信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="付款金额:"
              prop="payment_amount"
            >
              <form-input
                :numberVal="formData.payment_amount"
                :disabled="false"
                @setVal="setVal"
                :keyName="'payment_amount'"
              ></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="付款方式:"
              style="margin-bottom:0px"
              prop="pay_method"
            >
              <img src="@/assets/img/pay_methods.png" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="tips"
          style="font-weight:bold"
        >请对公转账到我公司以下银行账户，付款时请备注产品名称：</el-row>
        <el-row class="tips">公司名称：易筑网络科技(苏州)有限公司</el-row>
        <el-row class="tips">开户银行：农业银行苏州斜塘支行</el-row>
        <el-row class="tips">银行账号：10550701040016807</el-row>
        <el-row
          class="tips"
          style="margin-bottom:20px"
        >联系电话：18606212894</el-row>
        <el-form-item
          label="上传附件:"
          prop="attachment"
        >
          <eip-attachment
            v-model="formData.attachment"
            model-name="formData.attachment"
            :permission="'w'"
            propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
            accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
            limit="10"
            displayType="table"
            isInputEdit=""
            :configAttributes="{}"
            :multiple="true"
          >
            <span slot="labeldesc">附件</span>
          </eip-attachment>
        </el-form-item>
        <el-form-item
          label="备注:"
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            type="textarea"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="beforeCloseDialog">取消</el-button>
      <el-button
        type="primary"
        @click="submit"
        v-loading="loading"
      >保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import FormInput from './formInput.vue'
export default {
  components: { FormInput },
  data() {
    return {
      drawerSize: '70%',
      formData: {
        payment_time: '',
        payment_no: '',
        payment_amount: 0,
        pay_method: '1',
        payment_status: '1',
        tachment: '',
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0,
        remarks: '',
        attachment: ''
      },
      rules: {
        reviewer_results: [{ required: true, message: '请确认审核结果！', trigger: 'blur' }]
      },
      importurlWl: '/system/file/v1/upload',
      loading: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    orderId: {
      type: String,
      default: () => ''
    },
    paymentId: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.formData.payment_time = utils.formatDate(new Date())
      let arr = this.formData.payment_time.split(' ')
      this.formData.payment_time = arr[0]
      if (this.orderId && !this.paymentId) {
        this.$http.get('${third}/costcenter/third_order/' + this.orderId).then((res) => {
          if (res.data) {
            this.formData.refId = res.data.id
            const a = this.formData
            const b = res.data
            const newObject = {}
            Object.assign(newObject, a, b)
            this.formData = newObject
            this.formData.id = ''
            this.formData.remark = ''
          }
        })
      }
      if (this.paymentId) {
        this.$http.get('${third}/costcenter/third_payment/' + this.paymentId).then((res) => {
          if (res.data) {
            this.formData.refId = res.data.id
            const a = this.formData
            const b = res.data
            const newObject = {}
            Object.assign(newObject, a, b)
            this.formData = newObject
          }
        })
      }
    },
    //查看订单详情
    showOrderDetail() {
      this.$emit('showOrderDetail',this.orderId)
    },
    //千分位组件值回写
    setVal(keyName, val) {
      this.formData[keyName] = val
    },
    //取消/关闭弹窗
    beforeCloseDialog() {
      this.$emit('closePayment')
    },
    //提交订单确认
    submit() {
      this.loading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.isEdit) {
            this.$http.post('${third}/costcenter/third_payment/', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closePayment')
                this.$message.info('订单付款成功！')
              }
            })
          } else {
            this.$http.put('${third}/costcenter/third_payment/', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closePayment')
                this.$message.info('编辑保存成功！')
              }
            })
          }
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
/deep/.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
.tips {
  padding-left: 120px;
  font-size: 14px;
  color: #101010;
}
/deep/.el-input-group__append {
  background-color: unset;
  border: 0;
}
</style>
